import React, { useCallback, useEffect, useState } from 'react';
import { TextFormControlProps } from './models/TextFormControl.interfaces';
import './TextFormControl.scss';

export const TextFormControl = (
  {
    autoComplete,
    containerClass,
    controlName,
    controlType,
    defaultValue,
    errorText,
    headerText,
    id,
    isValidCallback,
    onBlurCallback,
    onChangeCallback,
    pattern,
    min,
    max,
    maxLength,
    minLength,
    setFocus,
    required=true
  }: TextFormControlProps
): JSX.Element => {

  const [isTouched, setIsTouched] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(false);

  const onBlurHandler = useCallback((event: React.FocusEvent<HTMLInputElement, Element>) => {
    !isTouched && setIsTouched(true);
    onBlurCallback && onBlurCallback(event);
  }, [isTouched, onBlurCallback]);

  const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>): void => {
    
    if (pattern){
      const regex = new RegExp(pattern);
      setIsValid(regex.test(event.currentTarget.value));
    }
    
    onChangeCallback && onChangeCallback(event);
    
  }, [onChangeCallback, pattern]);

  useEffect(() => {
    isValidCallback && isValidCallback(isValid);
    
  }, [isValid, isValidCallback]);


  return (
    <div className={`row row-cols-1 ${containerClass ? containerClass : ''}`}>
      {
        (isTouched && !isValid) &&
        <div className="col nqt-text-form-control--error"
          dangerouslySetInnerHTML={{__html: errorText ? errorText : ''}}>
        </div>
      }
      <label htmlFor={id} className="col nqt-text-form-control--header">{headerText}</label>
      <input id={id}
        ref={(el) => (setFocus && !isTouched) && el?.focus()}
        defaultValue={defaultValue}
        onChange={onChangeHandler}
        onBlur={onBlurHandler}
        autoComplete={autoComplete}
        min={min}
        max={max}
        maxLength={maxLength}
        minLength={minLength}
        name={controlName}
        type={controlType ? controlType : 'text'}
        className="col nqt-text-form-control"
        pattern={pattern}
        required={required}/>
    </div>
  );
};